// common/config.dev.js
export default {
  host: process.env.VUE_APP_API_HOST || 'http://192.168.0.105',
  port: process.env.VUE_APP_API_PORT || 5465,
  socketurl: process.env.VUE_APP_WS_URL || 'ws://192.168.0.105:5465',
};